export const countryData = [
  {
    id: "AO",
    continent: "AF",
    name: "Angola",
  },
  {
    id: "BF",
    continent: "AF",
    name: "Burkina Faso",
  },
  {
    id: "BI",
    continent: "AF",
    name: "Burundi",
  },
  {
    id: "BJ",
    continent: "AF",
    name: "Benin",
  },
  {
    id: "BW",
    continent: "AF",
    name: "Botswana",
  },
  {
    id: "CD",
    continent: "AF",
    name: "Congo, the Democratic Republic of the",
  },
  {
    id: "CF",
    continent: "AF",
    name: "Central African Republic",
  },
  {
    id: "CG",
    continent: "AF",
    name: "Congo",
  },
  {
    id: "CI",
    continent: "AF",
    name: "Cote d'Ivoire",
  },
  {
    id: "CM",
    continent: "AF",
    name: "Cameroon",
  },
  {
    id: "CV",
    continent: "AF",
    name: "Cape Verde",
  },
  {
    id: "DJ",
    continent: "AF",
    name: "Djibouti",
  },
  {
    id: "DZ",
    continent: "AF",
    name: "Algeria",
  },
  {
    id: "EG",
    continent: "AF",
    name: "Egypt",
  },
  {
    id: "EH",
    continent: "AF",
    name: "Western Sahara",
  },
  {
    id: "ER",
    continent: "AF",
    name: "Eritrea",
  },
  {
    id: "ET",
    continent: "AF",
    name: "Ethiopia",
  },
  {
    id: "GA",
    continent: "AF",
    name: "Gabon",
  },
  {
    id: "GH",
    continent: "AF",
    name: "Ghana",
  },
  {
    id: "GM",
    continent: "AF",
    name: "Gambia",
  },
  {
    id: "GN",
    continent: "AF",
    name: "Guinea",
  },
  {
    id: "GQ",
    continent: "AF",
    name: "Equatorial Guinea",
  },
  {
    id: "GW",
    continent: "AF",
    name: "Guinea-Bissau",
  },
  {
    id: "KE",
    continent: "AF",
    name: "Kenya",
  },
  {
    id: "KM",
    continent: "AF",
    name: "Comoros",
  },
  {
    id: "LR",
    continent: "AF",
    name: "Liberia",
  },
  {
    id: "LS",
    continent: "AF",
    name: "Lesotho",
  },
  {
    id: "LY",
    continent: "AF",
    name: "Libya",
  },
  {
    id: "MA",
    continent: "AF",
    name: "Morocco",
  },
  {
    id: "MG",
    continent: "AF",
    name: "Madagascar",
  },
  {
    id: "ML",
    continent: "AF",
    name: "Mali",
  },
  {
    id: "MR",
    continent: "AF",
    name: "Mauritania",
  },
  {
    id: "MW",
    continent: "AF",
    name: "Malawi",
  },
  {
    id: "MZ",
    continent: "AF",
    name: "Mozambique",
  },
  {
    id: "NA",
    continent: "AF",
    name: "Namibia",
  },
  {
    id: "NE",
    continent: "AF",
    name: "Niger",
  },
  {
    id: "NG",
    continent: "AF",
    name: "Nigeria",
  },
  {
    id: "RW",
    continent: "AF",
    name: "Rwanda",
  },
  {
    id: "SC",
    continent: "AF",
    name: "Seychelles",
  },
  {
    id: "SD",
    continent: "AF",
    name: "Sudan",
  },
  {
    id: "SH",
    continent: "AF",
    name: "Saint Helena, Ascension and Tristan da Cunha",
  },
  {
    id: "SL",
    continent: "AF",
    name: "Sierra Leone",
  },
  {
    id: "SN",
    continent: "AF",
    name: "Senegal",
  },
  {
    id: "SO",
    continent: "AF",
    name: "Somalia",
  },
  {
    id: "SS",
    continent: "AF",
    name: "South Sudan",
  },
  {
    id: "ST",
    continent: "AF",
    name: "Sao Tome and Principe",
  },
  {
    id: "SZ",
    continent: "AF",
    name: "Swaziland",
  },
  {
    id: "TD",
    continent: "AF",
    name: "Chad",
  },
  {
    id: "TG",
    continent: "AF",
    name: "Togo",
  },
  {
    id: "TN",
    continent: "AF",
    name: "Tunisia",
  },
  {
    id: "TZ",
    continent: "AF",
    name: "Tanzania, United Republic of",
  },
  {
    id: "UG",
    continent: "AF",
    name: "Uganda",
  },
  {
    id: "ZA",
    continent: "AF",
    name: "South Africa",
  },
  {
    id: "ZM",
    continent: "AF",
    name: "Zambia",
  },
  {
    id: "ZW",
    continent: "AF",
    name: "Zimbabwe",
  },
  {
    id: "AE",
    continent: "AS",
    name: "United Arab Emirates",
  },
  {
    id: "AF",
    continent: "AS",
    name: "Afghanistan",
  },
  {
    id: "BD",
    continent: "AS",
    name: "Bangladesh",
  },
  {
    id: "BH",
    continent: "AS",
    name: "Bahrain",
  },
  {
    id: "BN",
    continent: "AS",
    name: "Brunei Darussalam",
  },
  {
    id: "BT",
    continent: "AS",
    name: "Bhutan",
  },
  {
    id: "CC",
    continent: "AS",
    name: "Cocos (Keeling) Islands",
  },
  {
    id: "CN",
    continent: "AS",
    name: "China",
  },
  {
    id: "HK",
    continent: "AS",
    name: "Hong Kong",
  },
  {
    id: "ID",
    continent: "AS",
    name: "Indonesia",
  },
  {
    id: "IL",
    continent: "AS",
    name: "Israel",
  },
  {
    id: "IN",
    continent: "AS",
    name: "India",
  },
  {
    id: "IQ",
    continent: "AS",
    name: "Iraq",
  },
  {
    id: "IR",
    continent: "AS",
    name: "Iran, Islamic Republic of",
  },
  {
    id: "JO",
    continent: "AS",
    name: "Jordan",
  },
  {
    id: "JP",
    continent: "AS",
    name: "Japan",
  },
  {
    id: "KG",
    continent: "AS",
    name: "Kyrgyzstan",
  },
  {
    id: "KH",
    continent: "AS",
    name: "Cambodia",
  },
  {
    id: "KP",
    continent: "AS",
    name: "Korea, Democratic People's Republic of",
  },
  {
    id: "KR",
    continent: "AS",
    name: "Korea, Republic of",
  },
  {
    id: "KT",
    continent: "AS",
    name: "Saint Kitts and Nevis",
  },
  {
    id: "KW",
    continent: "AS",
    name: "Kuwait",
  },
  {
    id: "LA",
    continent: "AS",
    name: "Lao People's Democratic Republic",
  },
  {
    id: "LB",
    continent: "AS",
    name: "Lebanon",
  },
  {
    id: "LK",
    continent: "AS",
    name: "Sri Lanka",
  },
  {
    id: "MM",
    continent: "AS",
    name: "Myanmar",
  },
  {
    id: "MN",
    continent: "AS",
    name: "Mongolia",
  },
  {
    id: "MO",
    continent: "AS",
    name: "Macao",
  },
  {
    id: "MV",
    continent: "AS",
    name: "Maldives",
  },
  {
    id: "MY",
    continent: "AS",
    name: "Malaysia",
  },
  {
    id: "NP",
    continent: "AS",
    name: "Nepal",
  },
  {
    id: "OM",
    continent: "AS",
    name: "Oman",
  },
  {
    id: "PH",
    continent: "AS",
    name: "Philippines",
  },
  {
    id: "PK",
    continent: "AS",
    name: "Pakistan",
  },
  {
    id: "PS",
    continent: "AS",
    name: "Palestinian, State of",
  },
  {
    id: "QA",
    continent: "AS",
    name: "Qatar",
  },
  {
    id: "SA",
    continent: "AS",
    name: "Saudi Arabia",
  },
  {
    id: "SG",
    continent: "AS",
    name: "Singapore",
  },
  {
    id: "SY",
    continent: "AS",
    name: "Syrian Arab Republic",
  },
  {
    id: "TH",
    continent: "AS",
    name: "Thailand",
  },
  {
    id: "TJ",
    continent: "AS",
    name: "Tajikistan",
  },
  {
    id: "TL",
    continent: "AS",
    name: "Timor-Leste",
  },
  {
    id: "TM",
    continent: "AS",
    name: "Turkmenistan",
  },
  {
    id: "TW",
    continent: "AS",
    name: "Taiwan",
  },
  {
    id: "UZ",
    continent: "AS",
    name: "Uzbekistan",
  },
  {
    id: "VN",
    continent: "AS",
    name: "Viet Nam",
  },
  {
    id: "YE",
    continent: "AS",
    name: "Yemen",
  },
  {
    id: "AD",
    continent: "EU",
    name: "Andorra",
  },
  {
    id: "AL",
    continent: "EU",
    name: "Albania",
  },
  {
    id: "AM",
    continent: "EU",
    name: "Armenia",
  },
  {
    id: "AT",
    continent: "EU",
    name: "Austria",
  },
  {
    id: "AZ",
    continent: "EU",
    name: "Azerbaijan",
  },
  {
    id: "BA",
    continent: "EU",
    name: "Bosnia and Herzegovina",
  },
  {
    id: "BE",
    continent: "EU",
    name: "Belgium",
  },
  {
    id: "BG",
    continent: "EU",
    name: "Bulgaria",
  },
  {
    id: "BY",
    continent: "EU",
    name: "Belarus",
  },
  {
    id: "CH",
    continent: "EU",
    name: "Switzerland",
  },
  {
    id: "CY",
    continent: "EU",
    name: "Cyprus",
  },
  {
    id: "CZ",
    continent: "EU",
    name: "Czech Republic",
  },
  {
    id: "DE",
    continent: "EU",
    name: "Germany",
  },
  {
    id: "DK",
    continent: "EU",
    name: "Denmark",
  },
  {
    id: "EE",
    continent: "EU",
    name: "Estonia",
  },
  {
    id: "ES",
    continent: "EU",
    name: "Spain",
  },
  {
    id: "FI",
    continent: "EU",
    name: "Finland",
  },
  {
    id: "FO",
    continent: "EU",
    name: "Faroe Islands",
  },
  {
    id: "FR",
    continent: "EU",
    name: "France",
  },
  {
    id: "GB",
    continent: "EU",
    name: "United Kingdom",
  },
  {
    id: "GE",
    continent: "EU",
    name: "Georgia",
  },
  {
    id: "GR",
    continent: "EU",
    name: "Greece",
  },
  {
    id: "HR",
    continent: "EU",
    name: "Croatia",
  },
  {
    id: "HU",
    continent: "EU",
    name: "Hungary",
  },
  {
    id: "IE",
    continent: "EU",
    name: "Ireland",
  },
  {
    id: "IS",
    continent: "EU",
    name: "Iceland",
  },
  {
    id: "IT",
    continent: "EU",
    name: "Italy",
  },
  {
    id: "KZ",
    continent: "EU",
    name: "Kazakhstan",
  },
  {
    id: "LI",
    continent: "EU",
    name: "Liechtenstein",
  },
  {
    id: "LT",
    continent: "EU",
    name: "Lithuania",
  },
  {
    id: "LU",
    continent: "EU",
    name: "Luxembourg",
  },
  {
    id: "LV",
    continent: "EU",
    name: "Latvia",
  },
  {
    id: "MD",
    continent: "EU",
    name: "Moldova, Republic of",
  },
  {
    id: "ME",
    continent: "EU",
    name: "Montenegro",
  },
  {
    id: "MK",
    continent: "EU",
    name: "North Macedonia",
  },
  {
    id: "MT",
    continent: "EU",
    name: "Malta",
  },
  {
    id: "NL",
    continent: "EU",
    name: "Netherlands",
  },
  {
    id: "NO",
    continent: "EU",
    name: "Norway",
  },
  {
    id: "PL",
    continent: "EU",
    name: "Poland",
  },
  {
    id: "PT",
    continent: "EU",
    name: "Portugal",
  },
  {
    id: "RO",
    continent: "EU",
    name: "Romania",
  },
  {
    id: "RS",
    continent: "EU",
    name: "Serbia",
  },
  {
    id: "RU",
    continent: "EU",
    name: "Russian Federation",
  },
  {
    id: "SE",
    continent: "EU",
    name: "Sweden",
  },
  {
    id: "SI",
    continent: "EU",
    name: "Slovenia",
  },
  {
    id: "SK",
    continent: "EU",
    name: "Slovakia",
  },
  {
    id: "SM",
    continent: "EU",
    name: "San Marino",
  },
  {
    id: "TR",
    continent: "EU",
    name: "Turkey",
  },
  {
    id: "UA",
    continent: "EU",
    name: "Ukraine",
  },
  {
    id: "VA",
    continent: "EU",
    name: "Holy See (Vatican City State)",
  },
  {
    id: "XK",
    continent: "EU",
    name: "Kosovo",
  },
  {
    id: "AG",
    continent: "SA",
    name: "Antigua and Barbuda",
  },
  {
    id: "AI",
    continent: "SA",
    name: "Anguilla",
  },
  {
    id: "AW",
    continent: "SA",
    name: "Aruba",
  },
  {
    id: "BB",
    continent: "SA",
    name: "Barbados",
  },
  {
    id: "BM",
    continent: "SA",
    name: "Bermuda",
  },
  {
    id: "BS",
    continent: "SA",
    name: "Bahamas",
  },
  {
    id: "BZ",
    continent: "SA",
    name: "Belize",
  },
  {
    id: "CA",
    continent: "NA",
    name: "Canada",
  },
  {
    id: "CR",
    continent: "SA",
    name: "Costa Rica",
  },
  {
    id: "CU",
    continent: "SA",
    name: "Cuba",
  },
  {
    id: "CW",
    continent: "SA",
    name: "Curacao",
  },
  {
    id: "DM",
    continent: "SA",
    name: "Dominica",
  },
  {
    id: "DO",
    continent: "SA",
    name: "Dominican Republic",
  },
  {
    id: "GD",
    continent: "SA",
    name: "Grenada",
  },
  {
    id: "GL",
    continent: "EU",
    name: "Greenland",
  },
  {
    id: "GP",
    continent: "SA",
    name: "Guadeloupe",
  },
  {
    id: "GT",
    continent: "SA",
    name: "Guatemala",
  },
  {
    id: "HN",
    continent: "SA",
    name: "Honduras",
  },
  {
    id: "HT",
    continent: "SA",
    name: "Haiti",
  },
  {
    id: "JM",
    continent: "SA",
    name: "Jamaica",
  },
  {
    id: "KN",
    continent: "SA",
    name: "Saint Kitts and Nevis",
  },
  {
    id: "KY",
    continent: "SA",
    name: "Cayman Islands",
  },
  {
    id: "LC",
    continent: "SA",
    name: "Saint Lucia",
  },
  {
    id: "MX",
    continent: "NA",
    name: "Mexico",
  },
  {
    id: "NI",
    continent: "SA",
    name: "Nicaragua",
  },
  {
    id: "PA",
    continent: "SA",
    name: "Panama",
  },
  {
    id: "PM",
    continent: "SA",
    name: "Saint Pierre and Miquelon",
  },
  {
    id: "PR",
    continent: "NA",
    name: "Puerto Rico",
  },
  {
    id: "SV",
    continent: "SA",
    name: "El Salvador",
  },
  {
    id: "US",
    continent: "NA",
    name: "United States",
  },
  {
    id: "VC",
    continent: "SA",
    name: "Saint Vincent and the Grenadines",
  },
  {
    id: "AS",
    continent: "OC",
    name: "American Samoa",
  },
  {
    id: "AU",
    continent: "OC",
    name: "Australia",
  },
  {
    id: "FJ",
    continent: "OC",
    name: "Fiji",
  },
  {
    id: "NZ",
    continent: "OC",
    name: "New Zealand",
  },
  {
    id: "PG",
    continent: "OC",
    name: "Papua New Guinea",
  },
  {
    id: "SB",
    continent: "OC",
    name: "Solomon Islands",
  },
  {
    id: "AR",
    continent: "SA",
    name: "Argentina",
  },
  {
    id: "BO",
    continent: "SA",
    name: "Bolivia, Plurinational State of",
  },
  {
    id: "BR",
    continent: "SA",
    name: "Brazil",
  },
  {
    id: "CL",
    continent: "SA",
    name: "Chile",
  },
  {
    id: "CO",
    continent: "SA",
    name: "Colombia",
  },
  {
    id: "EC",
    continent: "SA",
    name: "Ecuador",
  },
  {
    id: "GF",
    continent: "SA",
    name: "French Guiana",
  },
  {
    id: "GY",
    continent: "SA",
    name: "Guyana",
  },
  {
    id: "PE",
    continent: "SA",
    name: "Peru",
  },
  {
    id: "PY",
    continent: "SA",
    name: "Paraguay",
  },
  {
    id: "SR",
    continent: "SA",
    name: "Suriname",
  },
  {
    id: "UY",
    continent: "SA",
    name: "Uruguay",
  },
  {
    id: "VE",
    continent: "SA",
    name: "Venezuela, Bolivarian Republic of",
  },
];
